import React from 'react';
import style from './style.module.scss';
import {Label as ProductLabel, renderLabelTooltip} from '../Label';
import {Typography} from 'components/Typography';
import {IProductSnippet, TProductLabel} from 'shared/types/productSnippet.types';

type TInStockLabelProps = TProductLabel &
    Pick<IProductSnippet, 'id'> &
    Pick<IProductSnippet['analytics'], 'onStockClick'>;

export const InStockLabel = (props: TInStockLabelProps) => {
    const {code, tooltip, title, url, id, onStockClick} = props;

    return (
        <ProductLabel className={style.main} key={code} id={id} url={url} tooltip={renderLabelTooltip(tooltip)}>
            <Typography
                variant={'label-10-r'}
                onClick={() => {
                    onStockClick(url);
                }}
            >
                {title}
            </Typography>
        </ProductLabel>
    );
};
